<template>
  <div v-if="entity" style="border:1px solid green;padding:10px">
    <EntityZ :entity="entity" />
    <slot />
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import EntityZ from "@/components/link/EntityZ";
function initialState() {
  return {
    entity: null
  };
}
export default {
  name: "Entity",
  props: ["id"],
  components: { EntityZ },
  data: function() {
    return initialState();
  },
  methods: {
    fetchEntity() {
      nbmlaw.get(`/cors/admin/directory/entities/${this.id}`).then(response => {
        // console.log(response.data);
        this.entity = response.data;
      });
    },
    update() {
      this.fetchEntity();
    }
  },
  watch: {
    id: {
      immediate: true,
      handler() {
        if (this.id) {
          this.update();
        } else {
          Object.assign(this.$data, initialState());
        }
      }
    },
    entity: {
      handler() {
        this.$emit("loaded", this.entity ? true : false);
        this.$emit("loadedEntity", this.entity);
      }
    }
  }
};
</script>